import { useCallback, useState } from "react"
import { IconButton, Tooltip } from "@mui/material"
import { Share } from "@mui/icons-material"
import type { SkillCatalogSkill } from "connected-components/skills/types"
import { skillResourceId } from "connected-components/skills/utils/tier"
import { SkillShareDialog } from "./skill-share-dialog"

interface SkillShareButtonProps {
  skill: SkillCatalogSkill
  mode?: "share" | "manage"
}

export function SkillShareButton({ skill, mode = "share" }: SkillShareButtonProps) {
  const [open, setOpen] = useState(false)
  const onOpen = useCallback(() => setOpen(true), [])
  const onClose = useCallback(() => setOpen(false), [])
  const resourceId = skillResourceId(skill)

  if (resourceId == null) return null

  const tooltip = mode === "manage" ? "Manage sharing" : "Share skill"
  const label = mode === "manage" ? `Manage sharing for ${skill.name}` : `Share ${skill.name}`

  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton aria-label={label} onClick={onOpen}>
          <Share />
        </IconButton>
      </Tooltip>
      {open && <SkillShareDialog open={open} onClose={onClose} skill={skill} resourceId={resourceId} mode={mode} />}
    </>
  )
}
